<template>
  <form action="">
      <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
              <p class="modal-card-title mr-5">Add new unit term</p>
              <button
                  type="button"
                  class="delete"
                  @click="$emit('close')"/>
          </header>
          <section class="modal-card-body">
              <b-field label="Unit term">
                <b-input
                  placeholder="e.g. pinch"
                  v-model.trim="value.term">
                </b-input>
              </b-field>
              <b-field label="Plural">
                <b-tooltip label="Leave blank if no plural is needed" position="is-top">
                  <b-input
                    v-model.trim="value.plural"
                    placeholder="e.g. pinches"
                    />
                </b-tooltip>
              </b-field>
          </section>
          <footer class="modal-card-foot">
              <b-button
                  label="Close"
                  @click="$emit('close')" />
              <b-button
                  label="Add"
                  :disabled="isAddDisabled"
                  type="is-primary"
                  @click="add"/>
          </footer>
      </div>
    </form>

</template>

<script>
import db from "@/firebase/db"

export default {
  name: 'AddNewPrepModal',
  props: {
    input: String
  },
  data() {
    return {
      value: null
    }
  },
  created() {
    this.value =  { term: this.input, plural: null };
  },
  computed: {
    isAddDisabled() {
      return this.value.term == null || this.value.term.trim() == ""
    }
  },
  methods: {
    add() {

      let newTerm = this.value.term.toLowerCase().trim()
      if (newTerm == "") {
        return;
      }
      let newUnit = {
        created_at: Date.now(),
        term: newTerm,
        plural: this.value.plural
      }
      db.collection("ingredient_units").add(newUnit)
      .then(() => {
        this.$buefy.toast.open({type: 'is-success', message: `Ingredient unit successfully added!`})
        this.$emit("unit-added", newUnit)
        this.$emit("close")
      })
      .catch((error) => {
        this.$buefy.toast.open({type: 'is-danger', message: `Error adding ingredient unit: ${error}`})
      });

    }
  }
}
</script>

<style scoped>
</style>
